import { ErrorHandler} from "@angular/core";

/**
 * Salaxy error handler.
 */
export class SalaxyErrorHandler extends ErrorHandler {

    /**
     * Default constructor.
     */
    constructor() {
        super();
    }

    /** Error handler with error http-status info if available. */
    public handleError(error: any, status: number = 0) {
        super.handleError(error);
    }
}
